<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <!-- <b-breadcrumb :items="breadcrumbs"/>        -->
         <b-card>
            <div slot="header">
              <strong>  {{subtitle}}</strong>
              <div class="card-header-actions" >
                <button class="btn btn-sm btn-primary mr-4 btn-pill" v-on:click="useradd()"  type="button"><i class="fa fa-plus"></i> Add New</button>
              <!--   <button class="btn btn-sm btn-primary" v-on:click="search()" type="button">Search</button> -->
                 <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button"><i class="fa fa-refresh"></i></button>
              </div>
            </div>
            <div id="adduser"  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;" class="mb-1">
              <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
               <input type="hidden" name="chkEditVal" id="chkEditVal" value="0">
                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="first name">First Name</label>
                      <b-form-input type="text" name="first name" v-model="customer.deliveryagentfirstname" v-validate="'required|alpha|min:3|max:30'" :class="{'input': true, 'text-danger': errors.has('form-1.first name') }" placeholder="Enter First Name">                       
                       </b-form-input>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('first name')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.first name')" class="help text-danger">{{ errors.first('form-1.first name') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="last name">Last Name</label>
                      <b-input-group class="mb-3">                     
                        <b-form-input class="input" type="text" name="last name" v-model="customer.deliveryagentlastname" v-validate="'required|alpha|min:3|max:30'" :class="{'input': true, 'text-danger': errors.has('form-1.last name') }" placeholder="Enter Last Name">
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('last name')" ></i>
                      </span>
                         <span style="width:240px" v-show="errors.has('form-1.last name')" class="help text-danger">{{ errors.first('form-1.last name') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="addmobilenumber">Mobile Number</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="addmobilenumber" name="mobile number" maxlength="10" v-model="customer.deliveryagentmobilenumber" v-validate="'required|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-1.mobile number') }" placeholder="Enter Mobile Number" >
                          </b-form-input>  
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('mobile number')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.mobile number')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-1.mobile number') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="Password">Password</label>
                      <b-input-group class="mb-3">
                         <b-form-input class="input" type="password" name="password" minlength="6" maxlength="14" v-model="customer.password" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.password') }" placeholder="Enter Password">
                         </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('password')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.password')" id="passwordtxt" class="help text-danger">{{ errors.first('form-1.password') }}
                      </code>                      
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="pincode">Vehicle Number</label>
                      <b-input-group class="mb-3">
                         <input class="input" type="hidden" name="pincode" id="deliveryagentpincodedev" maxlength="6" v-validate="'required|digits:6'" :class="{'input': true, 'text-danger': errors.has('form-1.pincode') }" placeholder="Enter Location ID">
                       
                        <b-form-input class="input" type="text" v-model="customer.vehicleno" name="vehicleno" id="vehicleno" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.vehicleno') }" placeholder="Enter Vehicle Number">
                        </b-form-input>                         
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <span style="width:240px" v-show="errors.has('form-1.vehicleno')" class="help text-danger">{{ errors.first('form-1.vehicleno') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                      <b-form-group>
                        <label for="pincode">Status</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.isactive" name="status" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.status') }">
                          <option value="">--Select--</option>
                          <option value="1">Active</option>
                          <option value="0">InActive</option>
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('status')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.status')" id="statustxt" class="help text-danger">{{ errors.first('form-1.status') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                      <b-form-group>
                        <label for="pincode">User Type</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.usertype" name="usertype" >
                          <option value="0">--Select--</option>
                         <!--  <option value="1">SDD</option>
                          <option value="2">NDD</option> -->
                          <option value="3">Try & Buy</option>
                          <option value="4">3PL</option>


                        </b-form-select>
                        </b-input-group>
                      
                      </b-form-group>
                  </b-col>
                </b-row>
                <footer class="column has-text-right">
                <b-button variant="primary" size="md" type="submit">Save</b-button>
                </footer>
              </b-form>
            </div>
            <div id="search"  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;" class="mb-1">
              <b-form @submit.prevent="searchonclick('form-4')" data-vv-scope="form-4">
                <b-row>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="first name">First Name</label>
                      <b-input-group class="mb-3">
                        <b-form-input class="input" type="text" v-validate="'alpha_spaces'" :class="{'input': true, 'text-danger': errors.has('form-4.firstname') }" name="firstname" v-model="searchObj.deliveryagentfirstname" placeholder="Enter First Name">
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('firstname')" ></i>
                      </span>
                      
                      <span style="width:240px" v-show="errors.has('form-4.firstname')" class="help text-danger">{{ errors.first('form-4.firstname') }}</span>                     
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col sm="3">
                    <b-form-group>
                      <label for="last name">Mobile Number</label>
                      <b-input-group class="mb-3">
                         <b-form-input class="input" type="text" id="searchmobilenumber" maxlength="10" v-validate="'numeric|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-4.mobilenumber') }" name="mobilenumber" v-model="searchObj.deliveryagentmobilenumber" placeholder="Enter Mobile Number">
                         </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('mobilenumber')" ></i>
                      </span>
                       <span style="width:240px" v-show="errors.has('form-4.mobilenumber')" class="help text-danger">{{ errors.first('form-4.mobilenumber') }}</span>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="last name">Delivery Allocation Location ID</label>
                      <b-input-group class="mb-3">
                         <b-form-input class="input" type="text" v-validate="'numeric'" :class="{'input': true, 'text-danger': errors.has('form-4.DeliveryPincode') }" name="DeliveryPincode" v-model="searchDeliveyPincode" placeholder="Enter Delivery Allocation Location ID">
                         </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">                     
                      <span style="width:240px" v-show="errors.has('form-4.DeliveryPincode')" class="help text-danger">{{ errors.first('form-4.DeliveryPincode') }}</span>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="last name">Pickup Allocation Location ID</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" v-validate="'numeric'" :class="{'input': true, 'text-danger': errors.has('form-4.PickupPincode') }" name="PickupPincode" v-model="pickuppincodes" placeholder="Enter Pickup Allocation Location ID">
                         </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span style="width:240px" v-show="errors.has('form-4.PickupPincode')" class="help text-danger">{{ errors.first('form-4.PickupPincode') }}</span>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>  
                  <b-col sm="3">
                    <b-form-group>
                      <label >Delivery Agent Master Id</label>
                      <b-input-group class="mb-3">
                         <b-form-input class="input" type="text" v-validate="'numeric'" :class="{'input': true, 'text-danger': errors.has('form-4.agentmasterid') }" name="agentmasterid" v-model="searchObj.deliveryagentmasterid" placeholder="Enter Delivery Agent Master Id">
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                       <span style="width:240px" v-show="errors.has('form-4.agentmasterid')" class="help text-danger">{{ errors.first('form-4.agentmasterid') }}</span>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label >Status</label>
                      <b-input-group class="mb-3">
                       <b-form-select v-model="searchObj.statuscode" name="status">
                        <option value="">--Select--</option>
                        <option value="Live">Live</option>
                        <option value="Profile Pending">Profile Pending</option>
                        <option value="Verfication Pending">Verfication Pending</option>
                      </b-form-select>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('status')" ></i>
                      </span>
                      <code v-show="errors.has('form-4.status')" id="statusmsg">{{ errors.first('form-1.status') }}
                      </code>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label >IsActive</label>
                      <b-input-group class="mb-3">
                        <b-form-select v-model="searchObj.isactive" name="isactive">
                          <option value="">--Select--</option>
                          <option value="1">Active</option>
                          <option value="0">InActive</option>
                        </b-form-select>
                      </b-input-group>
                     
                    </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label >Delivery Agent Location ID</label>
                      <b-input-group class="mb-3">
                        <b-form-input class="input" type="text" v-validate="'numeric'" :class="{'input': true, 'text-danger': errors.has('form-4.deliveryagentpincode') }" name="deliveryagentpincode" v-model="searchObj.deliveryagentpincode" placeholder="Enter Delivery Agent Location ID">
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                     
                       <span style="width:240px" v-show="errors.has('form-4.deliveryagentpincode')" class="help text-danger">{{ errors.first('form-4.deliveryagentpincode') }}</span>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                  <footer class="column has-text-right">
                  <b-button variant="primary" size="md" type="submit">Search</b-button>
                  </footer>
              </b-form>
            </div>          
             
              <b-row class="mb-4">
                <input type="hidden" name="isactiveId" id="isactiveId" value="">
                <input type="hidden" name="deliveryagentmasterId" id="deliveryagentmasterId" value="">
                  <b-col md="4" class="my-1">
                    <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                      <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                        <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" class="my-1">
                    <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
                      <b-input-group>
                        <b-form-select v-model="sortBy" :options="sortOptions">
                          <option slot="first" :value="null">-- none --</option>
                        </b-form-select>
                        <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
                          <option :value="false">Asc</option> <option :value="true">Desc</option>
                        </b-form-select>
                      </b-input-group>
                    </b-form-group>
                  </b-col>             
                 <!--  <b-col md="4" class="my-1">
                    <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                      <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                    </b-form-group>
                  </b-col> -->            
              </b-row> 
                <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              </b-col>          
              <!-- Main table element -->
              <b-table show-empty stacked="md" :busy="isBusy"  :items="items"  :fields="fields"  :current-page="currentPage" :bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" >
                  
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>

                <template slot="deliveryallocationlocation" slot-scope="row">
                   <b-button size="sm" class="mr-1" href="" data-toggle="tooltip" title="Add Delivery Location ID Allocate" @click="deliveryallocateModal(row.item)"> <i class="fa fa fa-pencil-square-o" ></i>
                  </b-button> 
                </template>

                <template slot="pickupallocationlocation" slot-scope="row">
                   <b-button size="sm" class="mr-1" href="" data-toggle="tooltip" title="Add Pickup Location ID Allocate" @click="PickupAllocateModal(row.item)">
                  <i class="fa fa fa-pencil-square-o" ></i>
                  </b-button> 
                </template>

                <template slot="isactive" slot-scope="row">
                  <span  @click="toggleInfoModal(row.item)" style="cursor:pointer;">
                  <span data-toggle="tooltip" title="InActive" v-if="row.item.isactive ==='0'" > 
                    <span class="badge badge-danger">Inative</span>
                  </span>  
                  <span data-toggle="tooltip" title="Active" v-else >
                    <span class="badge badge-success">Active</span>
                  </span>
                  </span>
                </template>

                <template slot="actions" slot-scope="row">
                  <b-button size="sm" title="Change Password" @click="editAgentMasterModal(row.item)" class="mr-1">
                  <i class="fa fa-key" ></i>
                  </b-button>
                  <b-button size="sm" @click="editinfoModal(row.item)" class="mr-1">
                    Edit
                  </b-button>
                <!--   <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                      View
                    </b-button> --> 
                     <b-button size="sm" class="mr-1" href="" data-toggle="tooltip" title="Dashbord" @click="deliveryDashbord(row.item, row.index, $event.target)"><i class="fa fa-mobile fa-2x" ></i>
                  </b-button>
                  <b-button size="sm" @click="availableivrmodal(row.item);showavailableivrmodal = true;"  >
                    <i class="fa fa-list-alt" aria-hidden="true"></i>
                  </b-button> 
                  <!-- <b-button size="sm" @click="row.toggleDetails">
                    {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
                  </b-button>-->
                </template>

                 <template slot="totalallocationallowed" slot-scope="row">
                  <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                  <span v-bind:id="'totalAllocationsAllowedClsapen_' + row.item.deliveryagentmasterid" >{{ row.item.totalallocationallowed ? row.item.totalallocationallowed : '0'}} </span>   <i class="fa fa fa-pencil-square-o" ></i>
                  </b-button>
                 </template>

                  <template slot="row-details" slot-scope="row">
                    <b-card>
                      <b-row>
                        <b-col sm="4">
                          <form @submit.prevent="addAllowedAllocations(row.item.deliveryagentmasterid)">       
                            <b-input-group >
                              <!-- Attach Left button -->
                               <b-form-input type="number"  min="0" @keyup="onBlur(row.item.deliveryagentmasterid)" v-bind:value="row.item.totalallocationallowed" v-bind:id="'totalAllocationsAllowedCls_' + row.item.deliveryagentmasterid" ></b-form-input>
                              <b-input-group-prepend>
                                <b-button type="submit"  variant="primary">
                                  Save <i class="fa fa-save"></i> 
                                </b-button>
                              </b-input-group-prepend>
                             
                            </b-input-group>  
                             <span style="display:none;" v-bind:id="'msg' + row.item.deliveryagentmasterid"></span>     
                          </form>
                        </b-col>
                         
                      </b-row>
                    </b-card>
                  </template>         
              </b-table>
            
          <!--     <b-col md="6" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col>   -->    
            <!-- Info modal -->         
        </b-card>
      </b-col>
    </b-row>



      <b-modal size="md" :id="dashboardinfo.id" :title="dashboardinfo.title" ok-only @hide="resetdashboardinfo" >
       <input type="hidden" name="deliveryboyId" id="deliveryboyId" v-model="deliveryboyId" value="">
       <input type="hidden" name="deliveryboyName" id="deliveryboyName" v-model="deliveryboyName" value="">
       
        <b-row v-for="value in dashboardinfo.data">     
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">{{ value.title}}</b-alert>

          </b-col> 
         
          <b-col cols="12" sm="6" lg="6" v-for="rowvalue in value.data">
            <b-card :no-body="true" footer-class="px-3 py-2">
              <b-card-body class="p-3 clearfix">
                <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i>
                <div class="h5 text-primary mb-0 mt-2">{{ rowvalue.cnt }}</div>
                <div class="text-muted  font-weight-bold font-xs">{{ rowvalue.name | capitalize }}</div>
              </b-card-body>
              <div slot="footer" v-if="rowvalue.pageType!=='codcollectable' ">
                <b-link v-if="rowvalue.pageType!=='codcollected' " class="font-weight-bold font-xs btn-block text-muted" href="javascript:void(0);" @click="getAllShipmentsListByStatus(rowvalue, $event.target)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div>
            </b-card>
          </b-col>   
        </b-row> 
       
        <b-row v-for="value in dashboardinfo3pl.data">     
          <b-col cols="12" sm="12" lg="12">
           <b-alert show variant="secondary">{{ value.title}}</b-alert>

          </b-col> 
         
          <b-col cols="12" sm="6" lg="6" v-for="rowvalue in value.data" >
            <b-card :no-body="true" footer-class="px-3 py-2">
              <b-card-body class="p-3 clearfix">
                <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i>
                <div class="h5 text-primary mb-0 mt-2">{{ rowvalue  ? rowvalue.cnt : 0 }}</div>
                <div class="text-muted  font-weight-bold font-xs">{{ rowvalue.name | capitalize }}</div>
              </b-card-body>
               <div slot="footer" >
                <b-link  class="font-weight-bold font-xs btn-block text-muted" href="javascript:void(0);" @click="getAllShipmentsListByStatus3PL(rowvalue, $event.target)">View Shipment <i class="fa fa-angle-right float-right font-lg"></i></b-link>
              </div> 
            </b-card>
          </b-col>   
        </b-row> 


      </b-modal>   
       
       
       <b-modal :id="consignmentPickUpPendingList.id" :title="consignmentPickUpPendingList.title" ok-only @hide="resetconsignmentPickUpPendingList" size="lg">  
<!-- <pre>{{ consignmentPickUpPendingList.data.length }}</pre> -->
            <div v-if="consignmentPickUpPendingList.data.length > 0">
            <div class="card" v-for="(shipmentlist, key, index) in consignmentPickUpPendingList.data">
               <div class="card-header">
                  <div>
                   <code>{{(key+1)}}] </code><strong>Shipment Id: </strong>{{ shipmentlist.shippingid }}
                      <div class="card-header-actions">
                        <b-badge variant="success" class="mr-4">{{ shipmentlist.deliverystatus }} </b-badge>                     
                      </div>
                  </div>
               </div>
               <div class="card-body">
                  <div class="row mb-4">
                     <div class="col-sm-4">
                        <!-- <h4 class="mb-3">Pickup:</h4> -->
                        <div><strong>{{ shipmentlist.pickuplocationname }}</strong></div>
                        <div>{{ shipmentlist.pickuplocationaddress }}</div>
                        <div><strong>Type:</strong>{{ shipmentlist.pickuplocationtype }}</div>                   
                        <div><strong>Hub ID:</strong> {{ shipmentlist.pickuplocationmasterid }}</div>
                        <div><strong>Lat Long:</strong> {{ shipmentlist.pickuplonglat }}</div> 
                        <div><strong>Handovertohub:</strong> <code>{{ shipmentlist.handovertohub }}</code></div>
                        <div><strong>Pickup Type:</strong> <code>{{ shipmentlist.pickuptype }}</code></div>                   
                     </div>
                     <div class="col-sm-4">
                        <!-- <h4 class="mb-3">Delivery:</h4> -->
                        <div><strong>{{ shipmentlist.customername }}</strong></div>                       
                        <div>{{ shipmentlist.shipaddress1 }}</div>
                       
                        <div><strong>Phone:</strong> {{ shipmentlist.shipmobilenumber1 }}</div>
                         <div><strong>Lat Long:</strong> {{ shipmentlist.shiplonglat }}</div>
                     </div> 
                     <div class="col-sm-4">
                        <!-- <h4 class="mb-3">Shipment Info:</h4>                         -->
                        <div>
                          <strong>Shipment Id:</strong>{{ shipmentlist.shippingid }}</div>                       
                        <div><strong>Order Id:</strong> 
                          {{ shipmentlist.orderid }}
                        </div>
                        <div v-if='shipmentlist.ordertype'>
                          <strong>Order Type:</strong> 
                          {{ shipmentlist.ordertype }}
                        </div>
                        <div>
                          <strong>Shipment Status:</strong> 
                          <code>{{ shipmentlist.shipmentstatus }}</code>
                        </div>
                        <div>
                          <strong>Service Type:</strong> 
                          <code>{{ shipmentlist.servicetype }}</code>
                        </div>
                        <div>
                          <strong>Delivery Type:</strong> 
                         <code> {{ shipmentlist.deliverystatus }}</code>
                        </div>
                        
                        <div v-if='shipmentlist.deliveryedd'>
                          <strong>Delivery Date:</strong> 
                          {{ shipmentlist.deliveryedd }}
                        </div>
                        <div v-if='shipmentlist.ordervalue'>
                          <strong>Total:</strong> 
                          {{ shipmentlist.ordervalue }}
                        </div>
                     </div>                 
                  </div>
                  <div class="table-responsive-sm" v-if="shipmentlist.prddetails.length > 0">
                     <table class="table  b-table table-bordered b-table-stacked-md">
                        <thead>
                           <tr>
                              <th class="center">Product Id</th>
                              <th>Item</th>
                               <th class="center">HSN code</th>
                              <th class="center">Quantity</th>
                             
                              <th class="right">Price</th>                      
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-for="prddetails in shipmentlist.prddetails">
                              <td class="center">{{prddetails.productid}}</td>
                              <td class="left">{{prddetails.productname}}</td> 
                               <td class="left">{{prddetails.hsncode}}</td>    
                              <td class="center">{{prddetails.productquantity}}</td>
                              
                              <td class="right">{{prddetails.productvalue}}</td>
                             
                           </tr>                   
                        </tbody>
                     </table>
                  </div> 
                  <div class="row"> 
                    <div class="col-sm-5 col-lg-4">
                    </div>              
                    <div class="col-sm-7 col-lg-8">
                      <table class="table table-clear b-table table-bordered b-table-stacked-md">
                         <tbody>
                            <tr>
                               <td class="left"><strong>Shipping Id:</strong></td>
                               <td class="right">{{ shipmentlist.shippingid }}</td>
                            </tr>
                            <tr >
                               <td class="left"><strong>Order Id:</strong></td>
                               <td class="right">{{ shipmentlist.orderid }}</td>
                            </tr>
                            <tr v-if='shipmentlist.ordertype'>
                               <td class="left"><strong>Order Type:</strong></td>
                               <td class="right">{{ shipmentlist.ordertype }}</td>
                            </tr>
                            
                             <tr v-if='shipmentlist.shipmentstatus'>
                               <td class="left"><strong>Shipment Status:</strong></td>
                               <td class="right">{{ shipmentlist.shipmentstatus }}</td>
                            </tr>
                            <tr v-if='shipmentlist.deliveryedd'>
                               <td class="left"><strong>Delivery date:</strong></td>
                               <td class="right">{{ shipmentlist.deliveryedd }}</td>
                            </tr>
                            <tr v-if='shipmentlist.ordervalue'>
                               <td class="left"><strong>Total</strong></td>
                               <td class="right"><strong>{{ shipmentlist.ordervalue }}</strong></td>
                            </tr>
                         </tbody>
                      </table>                   
                    </div>
                  </div>                           
               </div>                    
            </div>        
          </div>
          <template slot="modal-footer" slot-scope="{ cancel }">
           <a href="#" onclick="javascript:window.print();" class="btn btn-sm btn-info float-right ml-1"><i class="fa fa-print"></i> Print</a> 
          </template>
      </b-modal>
      <b-modal :id="allshipmentsbystatus.id" :title="allshipmentsbystatus.title" ok-only @hide="resetallshipmentsbystatus" size="lg">

          <div v-if="allshipmentsbystatus.data.length > 0">
            <div class="card" v-for="(shipmentlist, key, index) in allshipmentsbystatus.data">
               <div class="card-header">
                  <div>
                     <code>{{(key+1)}}] </code><strong>Shipment Id: </strong>{{ shipmentlist.shippingid }}
                      <div class="card-header-actions">
                        <b-badge variant="success" class="mr-4">{{ shipmentlist.deliverystatus }}</b-badge>

                        <b-badge variant="primary" v-if="shipmentlist.deliverystatus=='Pickup'" class="p-3"  @click="getconsignmentPickUpPendingList(shipmentlist, $event.target)">Views </b-badge>

                      </div>
                  </div>
               </div>
               <div class="card-body">
                  <div class="row mb-4">
                     <div class="col-sm-4">
                        <!-- <h4 class="mb-3">Pickup:</h4> -->
                        <div><strong>{{ shipmentlist.pickuplocationname }}</strong></div>
                        <div>{{ shipmentlist.pickuplocationaddress }}</div>
                        <div><strong>Pickup Type:</strong> <code>{{ shipmentlist.pickuplocationtype }} </code></div>                   
                        <div><strong>Hub ID:</strong> {{ shipmentlist.pickuplocationmasterid }}</div>
                        <div><strong>Lat Long:</strong> {{ shipmentlist.pickuplocation }}</div>  

                                   
                     </div>
                     <div class="col-sm-4">
                        <!-- <h4 class="mb-3">Delivery:</h4> -->
                        <div><strong>{{ shipmentlist.customername }}</strong></div>                       
                        <div>{{ shipmentlist.shipaddress }}</div>
                       
                        <div><strong>Phone:</strong> {{ shipmentlist.shipmobilenumber }}</div>
                         <div><strong>Lat Long:</strong> {{ shipmentlist.deliverylocation }}</div>
                     </div> 
                     <div class="col-sm-4">
                        <!-- <h4 class="mb-3">Shipment Info:</h4>                         -->
                        <div>
                          <strong>Shipment Id:</strong>{{ shipmentlist.shippingid }}</div>                       
                        <div><strong>Order Id:</strong> 
                          {{ shipmentlist.orderid }}
                        </div>
                        <div>
                          <strong>Order Type:</strong> 
                          {{ shipmentlist.ordertype }}
                        </div>
                        
                         <div>
                          <strong>Shipment Status:</strong> 
                          <code>{{ shipmentlist.shipmentstatus }}</code>
                        </div>
                        <div>
                          <strong>Service Type:</strong> 
                          <code>{{ shipmentlist.servicetype }}</code>
                        </div>
                        <div>
                          <strong>Delivery Type:</strong> 
                         <code> {{ shipmentlist.deliverystatus }}</code>
                        </div>
                        <div>
                         <strong>Return to:</strong> 
                         <code> {{ shipmentlist.rtoto }}</code>
                        </div>
                        
                        <div>
                          <strong>Delivery date:</strong> 
                          {{ shipmentlist.deliveryedd }}
                        </div>
                        <div v-if="shipmentlist.ordervalue!='0' && shipmentlist.ordervalue!='0.0'">
                          <strong>Total:</strong> 
                          {{ shipmentlist.ordervalue }}
                        </div>
                     </div>                 
                  </div>
                  <div v-if="shipmentlist.deliverystatus!='Pickup'">
                    <div class="table-responsive-sm" v-if="shipmentlist.prddetails.length > 0"  >
                       <table class="table  b-table table-bordered b-table-stacked-md">
                          <thead>
                             <tr>
                                <th class="center">Product Id</th>
                                <th>Item</th>
                                 <th class="center">Hsncode</th>
                                <th class="center">Quantity</th>
                                
                                <th class="right">Price</th>                      
                             </tr>
                          </thead>
                          <tbody>
                             <tr v-for="prddetails in shipmentlist.prddetails">
                                <td class="center">{{prddetails.productid}}</td>
                                <td class="left">{{prddetails.productname}}</td>        <td class="left">{{prddetails.hsncode}}</td>                   
                                <td class="center">{{prddetails.productquantity}}</td>
                                 
                                <td class="right">{{prddetails.productvalue}}</td>
                               
                             </tr>                   
                          </tbody>
                       </table>
                    </div>                 
                  </div>                           
               </div>                    
            </div>        
          </div>
          <template slot="modal-footer" slot-scope="{ cancel }">
           <a href="#" onclick="javascript:window.print();" class="btn btn-sm btn-info float-right ml-1"><i class="fa fa-print"></i> Print</a> 
          </template>
     <!--  <pre>{{ allshipmentsbystatus.data }}</pre> -->
      </b-modal>
      <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
      </b-modal>
      <b-modal title="Update Delivery Agent Info" v-model="editAgentMaster" @ok="editAgentMaster = false">
          <template slot="modal-header" slot-scope="{ close }">
          <h5>Update Delivery Agent Info</h5>
          </template>
          <template slot="default" slot-scope="{ hide }">
             <b-form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-5">
                <b-form-group
                  label="Mobile Number"
                  :label-cols="3" >
                  <b-form-input type="text" name="mobile number" maxlength="10" v-model="customer.editmobilenumber" v-validate="'required|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-5.mobile number') }" placeholder="Enter Mobile Number">
                  </b-form-input>
                  <span style="width:240px" v-show="errors.has('form-5.mobile number')" class="help text-danger">{{ errors.first('form-5.mobile number') }}</span>                 
                </b-form-group>
                <b-form-group
                  label="Vehicle Number"
                  :label-cols="3"
                  >                      
                   <b-form-input class="input" type="text" v-model="customer.editvehicleno" name="vehicleno"  v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-5.vehicleno') }" placeholder="Enter Vehicle Number">             
                  </b-form-input>
                  <span style="width:240px" v-show="errors.has('form-5.vehicleno')" class="help text-danger">{{ errors.first('form-5.vehicleno') }}</span>
                </b-form-group>
                      <b-form-group label="User Type" :label-cols="3">
                       
                        
                          <b-form-select v-model="customer.editusertype" name="editusertype" >
                          <option value="0">--Select--</option>
                         <!--  <option value="1">SDD</option>
                          <option value="2">NDD</option> -->
                          <option value="3">Try & Buy</option>
                          <option value="4">First Mile</option>

                        </b-form-select>
                       
                      </b-form-group>
                 
                <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button>
                  <b-button  size="sm" variant="danger" @click="editcancel()">cancel</b-button>
                </div>
              </b-form>
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
          </template>
      </b-modal> 
      <b-modal title="Confirmation Box" v-model="toggleInfo" size="md" @ok="toggleInfo = false">
        <template slot="modal-header" slot-scope="{ close }">
        <h5>Confirmation Box</h5>
        </template>
        <template slot="default" slot-scope="{ hide }">
          <form v-on:submit.prevent="activateInActivateDeliveryAgent(value)">
            <div class="modal-background"></div>
            <div class="modal-card">
              <section class="modal-card-body">
                <input type="hidden" v-model="customer.isactive" name="isactive" id="modalIsActiveChk">
                <span>Are you sure you want to change the status?</span>
              </section>
              <footer >
                <b-button variant="primary" size="sm" type="submit">Ok</b-button>
              </footer>
            </div>
          </form>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" variant="danger" @click="cancel()">
            Cancel
          </b-button>
          <!-- Button with custom close trigger value -->
        </template>
      </b-modal>
      <b-modal title="Delivery Allocation Location"  v-model="delivertLocationModal" size="md" @ok="delivertLocationModal = false" class="modal-info" ok-variant="info">
        <template slot="modal-header" slot-scope="{ close }">
        <h5>Delivery Allocation Location</h5>
        </template>
        <template slot="default" slot-scope="{ hide }">
           <b-form @submit.prevent="validateForm2('form-2')" data-vv-scope="form-2">
              <b-form-group
                label="Select Locations"             
                :label-cols="3"
                >
                <b-form-select v-model="customer.deliverypincodestextarea" name="pincodes" multiple id="textareapincodes" required>
                      <option disabled>--Select Locations--</option>
                      <option :value="value.locality_id" v-for="(value, index) in locations" >
                      {{ value.locality_name }}
                      </option>
                </b-form-select>
                <span v-show="errors.has('form-2.pincodes')" id="pincodemsg" class="help text-danger">{{ errors.first('form-2.pincodes') }}</span>
              </b-form-group>
            
              <div slot="footer" class="text-right">
                <b-button type="submit" size="sm" class="mr-4" variant="primary">Allocate</b-button>
                <b-button size="sm" variant="danger"  @click="CloseDeliveryAllocateModal">
            Cancel
          </b-button>
           </div>
            </b-form>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" variant="danger"  style="display:none" >
            Cancel
          </b-button>
          <!-- Button with custom close trigger value -->
        </template>
      </b-modal>
      <b-modal title="Pickup Allocation Location" v-model="pickupLocationModal" size="md" @ok="pickupLocationModal = false">
          <template slot="modal-header" slot-scope="{ close }">
          <h5 >Pickup Allocation Location</h5>
          </template>

          <template slot="default" slot-scope="{ hide }">
            <b-form @submit.prevent="validateForm3('form-3')" data-vv-scope="form-3">
              
              <b-form-group
                label="Select Locations"             
                :label-cols="3"
                >
                 <b-form-select v-model="customer.pickuppincodestextarea" name="pickuppincodes" multiple required>
                      <option disabled>--Select Locations--</option>
                      <option :value="value.locality_id"  v-for="(value, index) in locations">
                      {{ value.locality_name }}
                      </option>                 
                  </b-form-select>
                <span v-show="errors.has('form-3.pickuppincodes')" id="pincodemsg1" class="help text-danger">{{ errors.first('form-3.pickuppincodes') }}</span>
              </b-form-group>
            
              <div slot="footer" class="text-right">
                <b-button type="submit" size="sm" class="mr-4" variant="primary">Allocate</b-button>
                <b-button size="sm" variant="danger" @click="pickcancel()" >
              Cancel
            </b-button>            
              </div>
            </b-form>
          
          </template>

          <template slot="modal-footer" slot-scope="{ cancel }">
            <b-button size="sm" variant="danger" @click="cancel()" style="display:none">
              Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
          </template>
      </b-modal>
          <b-modal title="Show Available IVR Number List" v-model="showavailableivrmodal" @ok="showavailableivrmodal = false" >
          <template slot="modal-header" slot-scope="{ close }">
          <h5>Available IVR Number</h5>
          </template>
          <template slot="default" slot-scope="{ hide }">
             <!-- <b-form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-5" > -->
               
              <b-form-group>
                <div class="table-wrapper-scroll-y custom-scrollbar">

                  <table  class="table table-bordered table-striped mb-0">
                    <thead>
                      <tr>{{ivrdata.deliveryagentmasterid}}
                      
                      <!-- <th scope="col">Deliveryagentmasterid:{{items[0].deliveryagentmasterid}}</th> -->
                      
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="items in ivrdata">
                        <!-- <th scope="row">1</th> -->
                        <td >{{items.ivrnumber}}</td>
                      </tr>

                    </tbody>
                  </table>

                </div>

              </b-form-group>
                <!-- <b-form-select v-model="customer.deliverypincodestextarea" name="pincodes" multiple id="textareapincodes" required>
                      <option disabled>--Select Locations--</option>
                      <option :value="value.locality_id" v-for="(value, index) in locations" >
                      {{ value.locality_name }}
                      </option>
                </b-form-select> -->
                 
                <div slot="footer" class="text-right">
                 
                  <b-button  size="sm" variant="danger" @click="ivrmodalcancel()">cancel</b-button>
                </div>
              <!-- </b-form> -->
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
          </template>
      </b-modal>
      <b-modal title="Change Password" size="md" v-model="editAgentMastertoggleInfo" @ok="editAgentMastertoggleInfo = false">
        <template slot="modal-header" slot-scope="{ close }">
        <h5>Change Password</h5>
        </template>
        <template slot="default" slot-scope="{ hide }">
          <form @submit.prevent="validateForm4('form-4')" data-vv-scope="form-4">
            <div class="modal-background"></div>
            <div class="modal-card">
              <section class="modal-card-body">
                <div class="field">
                  <p class="control">
                    <b-form-input class="input" type="text" name="password" minlength="6" maxlength="14" v-model="customer.deliveryagentpassword" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-4.password') }"
                      placeholder="Enter password" />
                    <code v-show="errors.has('form-4.password')" class="help text-danger">{{ errors.first('form-4.password') }}</code>
                  </p>
                </div>
              </section>
              <footer class="text-right">
                <b-button size="sm" variant="primary" type="submit" class="mr-4">Update</b-button>
                 <b-button size="sm" variant="danger" @click="cancel()" >
            Cancel
          </b-button>
              </footer>
            </div>
          </form>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" variant="danger" @click="cancel()" style="display:none">
            Cancel
          </b-button>
          <!-- Button with custom close trigger value -->
        </template>
      </b-modal>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
export default {
  data: function() {
    return {
      name: "deliveryagentmaster",
      isBusy: false,      
      pickupLocationModal: false,
      delivertLocationModal: false,
      subtitle:'Delivery Agent Info',
      data: [],
      ClientData: [],
      clients: [],
      searchDeliveyPincode: "",
      pickuppincodes: "",
      customer: {},
      // selected:'',
      seen: true,
      searchObj: {},
      clientsIds: [],
      clientResult:[],
      toggleInfo: false,
      deliveryallocatetoggleInfo: false,
      pickupallocatetoggleInfo: false,
      serviceableclientstoggleInfo: false,
      editAgentMastertoggleInfo: false,
      editAgentMaster:false,
      locations: [],
      value: [],
      bordered: true,
      items:[],
      deliveryboyId:'',
      deliveryboyName:'',
      deliveryboyMb:'',
      customer:{
          deliverypincodestextarea:[],
          pickuppincodestextarea:[],
      },
      fields: [
          { key: 'deliveryagentmasterid', label: 'Id', sortable: true, sortDirection: 'desc' },
          { key: 'deliveryagentfirstname', label: 'First Name', sortable: true },
          { key: 'deliveryagentlastname', label: 'Last Name', sortable: true},
          { key: 'deliveryagentmobilenumber', label: 'Mobile Number', sortable: true},
          { key: 'vehicleno', label: 'Vehicle No', sortable: true},          
          { key: 'isactive', label: 'is Active', sortable: true},    
          { key: 'actions', label: 'Actions' },
          { key: 'deliveryallocationlocation', label: 'Delivery Allocation' },
          { key: 'pickupallocationlocation', label: 'Pickup Allocation' },
          { key: 'totalallocationallowed', label: 'Capacity'}
        ],
        totalRows: 0,
        currentPage: 1,
        showavailableivrmodal: false,
         ivrdata: [],
        //perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: true,
        sortDirection: 'desc',
        filter: null,
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
        dashboardinfo:{
           id: 'dashboard-modal',
           title: '',
           content: '',
           data: ''
        },
          dashboardinfo3pl:{
           id: 'dashboard-modal',
           title: '',
           content: '',
           data: ''
        },
        allshipmentsbystatus:{
           id: 'shipments-list-modal',
           title: '',
           content: '',
           data: ''
        },
        consignmentPickUpPendingList:{
           id: 'pending-list-modal',
           title: '',
           content: '',
           data: ''
        }
    };
  },
  created: function() {
    // console.log("In Created Function");
    //document.getElementById("showheader").value = "1";
    this.getlocations();
    this.displaydata();
  },
   computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
  mounted: function() {
    this.clients = [{ name: "a" }, { name: "b" }];
    //  var checkValidUser = auth.checkValidUser()
    //  if(checkValidUser){
    //    this.$router.push('dashboard')
    //  }
    //this.totalRows = this.items.length
  },
  methods: {
      reloadPage(){
      window.location.reload()
      },
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
      resetdashboardinfo(){
         this.dashboardinfo.title = ''
         this.dashboardinfo.content = ''
         this.dashboardinfo.data = ''
      },
      resetallshipmentsbystatus(){
         this.allshipmentsbystatus.title = ''
         this.allshipmentsbystatus.content = ''
         this.allshipmentsbystatus.data = ''
      },
      resetconsignmentPickUpPendingList(){
         this.consignmentPickUpPendingList.title = ''
         this.consignmentPickUpPendingList.content = ''
         this.consignmentPickUpPendingList.data = ''
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    getlocations: function(){
      this.$http
        .post(`${CONSTANTS.API_URL}/DeliveryAgentMaster/locationlist`)
        .then(result => {
          this.locations = result.body;
          // console.log('this.locations',this.locations);
        })
        .catch(ex => {
          alert(ex);
        });
    },
    displaydata: function() {
      this.isBusy = true;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const deliveryagentobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`
      };
      // console.log('deliveryagentobj',deliveryagentobj);
      this.$http
        .post(
          `${
            CONSTANTS.API_URL
          }/DeliveryAgentMaster.svc/DeliveryAgentMasterGetAll`,
          deliveryagentobj
        )
        .then(result => {
          if (result.body.length > 0) {
            this.isBusy = !this.isBusy
            this.data = result.body;
            this.items  = result.body;
            this.totalRows = result.body.length
          } else {
            this.isBusy = !this.isBusy
            this.data = result.body;
            this.items  = result.body;
            this.totalRows = result.body.length
          }
        })
        .catch(ex => {
          console.log("error", ex);
        });
      this.$http
        .post(`${CONSTANTS.API_URL}/ClientMasterGet`)
        .then(result => {
          this.ClientData = result.body;
        })
        .catch(ex => {
          alert(ex);
        });
    },
    useradd: function() {
      this.customer = {};
      this.customer.usertype='0';
      this.subtitle='Add Delivery Agent info';
      this.errors.clear("form-1");
      var search1 = document.getElementById("search");
      search1.style.display = "none";
      this.seen = !this.seen;
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var adduser = document.getElementById("adduser");
      adduser.style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      document.getElementById("deliveryagentpincodedev").value = userInfo.pickuplocationpincode;
      document.getElementById("deliveryagentpincodedev").disabled = true;
      document.getElementById("chkEditVal").value = "0";
    },
    refresh:function() {
      this.subtitle='Delivery Agent info';
      var search1 = document.getElementById("search");
      search1.style.display = "none";
      this.seen = !this.seen;
      var adduser = document.getElementById("adduser");
      adduser.style.display = "none";
      this.searchclear();
    },
    search: function() {
      this.subtitle='Search Delivery Agent info';

      var search1 = document.getElementById("search");
      search1.style.display = "block";
      this.seen = !this.seen;
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var adduser = document.getElementById("adduser");
      adduser.style.display = "none";
      this.searchclear();
    },
    searchclear: function() {
      this.searchObj = {};
      this.searchDeliveyPincode = "";
      this.pickuppincodes = "";
      this.errors.clear("form-4");
      this.displaydata();
    },
    searchonclick: function(scope) {
      this.$validator.validateAll(scope).then(result => {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        if (!result) {
          var myObj = JSON.parse(JSON.stringify(this.searchObj));
          if (this.searchDeliveyPincode !== "") {
            myObj.deliverypincodes = this.searchDeliveyPincode;
          }
          if (this.pickuppincodes !== "") {
            myObj.pickuppincodes = this.pickuppincodes;
          }
          if (userInfo.pickuplocationpincode !== "") {
            myObj.deliveryagentpincode = `${userInfo.pickuplocationpincode}`;
          }
          this.$http
            .post(
              `${
                CONSTANTS.API_URL
              }/DeliveryAgentMaster.svc/DeliveryAgentMasterGetAll`,
              myObj
            )
            .then(result => {
              if (
                result.body.returnmsg &&
                result.body.returnmsg === "UnSuccessful"
              ) {
                this.data = [];
                alert("Result not found");
              } else if (result.body.length === 0) {
                this.data = [];
                alert("Result not found");
              } else if (result.body.returnmsg === "error") {
                this.data = [];
                alert(result.body.returnvalue);
              } else {
                this.data = result.body;
              }
            })
            .catch(ex => {
              console.log("error", ex);
            });
        } else {
          console.log("error");
        }
      });
    },
    ivrmodalcancel: function() {
      this.customer = {};
     this.showavailableivrmodal = false;
    },
    availableivrmodal: function(value) {
      this.customer.deliveryagentmasterid = value.deliveryagentmasterid;
      var passwObj = {
        agentid: `${this.customer.deliveryagentmasterid}`
      }
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getavailableivrnumber`,passwObj).then(result => {
             if (result.body.returnmsg=="Successful") {
              this.ivrdata = result.body.returnvalue
              this.isBusy = !this.isBusy
            }
            else{
            this.ivrdata = []
            this.ivrdata= "No Record Found";
           
          }
          })
          .catch(ex => {
            console.log("error", ex);
          });
       // this.customer.deliveryagentmasterid = value.deliveryagentmasterid;      
       // this.availableivrmodal = !this.availableivrmodal;
    },
    onBlur: function(deliveryagentmasterid) {
      document.getElementById("msg" + deliveryagentmasterid).style.color = "";
      document.getElementById("msg" + deliveryagentmasterid).innerHTML = "";
      document.getElementById("msg" + deliveryagentmasterid).style.display =
        "none";
    },
    chkmobileVal() {
      var chkValidate = true;
     // var chknumb = /^[0789]{1}\d{9}$/;
      var chknumb = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;

      var mobilenumber = document.getElementById("addmobilenumber").value;
      if (
        mobilenumber.trim() === "0000000000" ||
        mobilenumber.trim().length < 10
      ) {
        chkValidate = false;
        return false;
      } else if (
        mobilenumber.trim() != "" &&
        !mobilenumber.trim().match(chknumb)
      ) {
        chkValidate = false;
        return false;
      }
      return (chkValidate = chkValidate);
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {          
          this.addAgentInfo();
        }
      });
    },
    validateForm2(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.AllocateDeliveryPincodes();
        }
      });
    },
    AllocateDeliveryPincodes: function() {
      var result = [];
        var deliverypin = this.customer.deliverypincodestextarea;
        var codes = deliverypin;
        var a = codes.indexOf(`${this.customer.deliveryagentpincode}`);
        if (a === -1) {
          codes.push(`${this.customer.deliveryagentpincode}`);
        }
        for (var q = 0; q < codes.length; q++) {
          var allpincode = codes[q].trim();
          if (allpincode !== "") {
            const pincodeObj = {
              deliverypincode: allpincode
            };
            result.push(pincodeObj);
          }
        }

        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        var deliveryObj = {
          deliveryagentmasterid: `${this.customer.deliveryagentmasterid}`,
          pincodes: JSON.stringify(result),
          lastmodifiedby: `${userInfo.sysemailid}`
        };
        if (typeof this.customer.deliveryagentmasterid !== "undefined") {

          this.$http
            .post(`${CONSTANTS.API_URL}/AllocateDeliveryPincodes`, deliveryObj)
            .then(result => {
              this.customer.deliverypincodestextarea = [];
              Utils.notify("Added successfully", "success");
               this.displaydata();
              this.delivertLocationModal = !this
                .delivertLocationModal;
                this.customer = {};
            })
            .catch(ex => {
              console.log("error", ex);
            });
        } else {
          alert("Please allocate delivery agent master id");
        }
      //}
    },
    CloseDeliveryAllocateModal: function() {
      this.customer = {};
      this.delivertLocationModal = !this.delivertLocationModal;
    },
    clearDeliveryPincode: function() {
      //document.getElementById("textareapincodes").value = "";
      this.customer.deliverypincodestextarea = [];
      //var pincode = document.getElementById("textareapincodes");
      //pincode.classList.remove("text-danger");
      document.getElementById("pincodemsg").innerHTML = "";
      document.getElementById("pincodemsg").style.display = "none";
      this.errors.clear("form-2");
    },
    ClosePickupAllocateModal: function() {
      this.customer = {};
      this.pickupallocatetoggleInfo = !this.pickupallocatetoggleInfo;
    },
    clearPickupPincode: function() {
      //document.getElementById("textareapincodes1").value = "";
      this.customer.pickuppincodestextarea = [];
      //var pincode = document.getElementById("textareapincodes1");
      //pincode.classList.remove("text-danger");
      document.getElementById("pincodemsg1").innerHTML = "";
      document.getElementById("pincodemsg1").style.display = "none";
      this.errors.clear("form-3");
    },
    validateForm4(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.changeAgentPassword();
        }
      });
    },
    validateForm5(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
           this.updateDeliveryAgent();
        }
      });
    },
    changeAgentPassword: function() {
      var result = [];
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      var passwObj = {
        deliveryagentmasterid: `${this.customer.deliveryagentmasterid}`,
        deliveryagentpassword: `${this.customer.deliveryagentpassword}`,
        lastmodifiedby: `${userInfo.sysemailid}`
      };
      if (typeof this.customer.deliveryagentmasterid !== "undefined") {
        this.$http
          .post(
            `${CONSTANTS.API_URL}/DeliveryAgentMaster/ChangePassword`,
            passwObj
          )
          .then(result => {
            alert("Password updated successfully");
            this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo;
            this.customer = {};
            this.displaydata();
          })
          .catch(ex => {
            console.log("error", ex);
          });
      }
    },
    cancel:function() {
      this.customer = {};
      this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo;
    },
    pickcancel:function() {
      this.customer = {};
      this.pickupLocationModal = !this.pickupLocationModal;
    },
    updateDeliveryAgent: function() {      
      var result = [];
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      var editusertype='0';
      if(this.customer.editusertype){
        editusertype=this.customer.editusertype;
      }
      var passwObj = {
        deliveryagentmasterid: `${this.customer.deliveryagentmasterid}`,
        deliveryagentmobilenumber: `${this.customer.editmobilenumber}`,
        vehicleno:`${this.customer.editvehicleno}`,
        lastmodifiedby: `${userInfo.sysemailid}`,
        usertype:editusertype,
      };  
      if (typeof this.customer.deliveryagentmasterid !== "undefined") {
        //DAUpdateVehicleDetail
        this.$http
          .post(
            `${CONSTANTS.API_URL}/DeliveryAgentMaster/DAUpdateVehicleDetails`,
            passwObj
          ).then(result => {
           if (result.body.returnmsg === "Successful") {
            alert("updated successfully");
            this.editAgentMaster = !this.editAgentMaster;
            this.customer = {};
            this.displaydata();
          }
          else
          {
            alert(result.body.returnvalue);
          }
          })
          .catch(ex => {
            console.log("error", ex);
          });
      }
    },    
    editcancel: function() {
      this.customer = {};
      this.editAgentMaster = !this.editAgentMaster;
    },
    editinfoModal: function(value) {
      // console.log('test ');
      // console.log(value);
      //  console.log('test ');
      this.customer.editmobilenumber = value.deliveryagentmobilenumber;
      this.customer.editvehicleno = value.vehicleno;
      this.customer.deliveryagentmasterid = value.deliveryagentmasterid;
      this.customer.editusertype = value.usertype;      
      this.editAgentMaster = !this.editAgentMaster;
    },
    toggleInfoModal: function(value) {    
      //debugger
      this.customer = value;
      if (value.isactive === "1") {
        //this.customer.isactive = true
      } else {
        //this.customer.isactive = false
      }
      if (typeof value !== "undefined") {
        document.getElementById("deliveryagentmasterId").value =
          value.deliveryagentmasterid;
        document.getElementById("isactiveId").value = value.isactive;
      }
      this.toggleInfo = !this.toggleInfo;
    },
    isJson: function(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    validateForm3(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.AllocatePickupPincodes();
        }
      });
    },
    AllocatePickupPincodes: function() {
      var result = [];
      //var validateflag = this.validatePickupPincodes();
      //if (validateflag) {
        //this.validatePickupPincodes();
        var pickuppin = this.customer.pickuppincodestextarea;
        var pickup = pickuppin;
        var a = pickup.indexOf(`${this.customer.deliveryagentpincode}`);
        if (a === -1) {
          pickup.push(`${this.customer.deliveryagentpincode}`);
        }
        // var dupArray = this.getDuplicateValue(pickup);
        // if (dupArray.length > 0) {
        //   Utils.notify("Duplicate pickup pincode - " + dupArray, "error");
        //   return true;
        // }
        for (var r = 0; r < pickup.length; r++) {
          var pickuppins = pickup[r].trim();
          if (pickuppins !== "") {
            const pincodeObj = {
              pickuppincode: pickuppins
            };
            result.push(pincodeObj);
          }
        }
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        var deliveryObj = {
          deliveryagentmasterid: `${this.customer.deliveryagentmasterid}`,
          pincodes: JSON.stringify(result),
          lastmodifiedby: `${userInfo.sysemailid}`
        };
        if (typeof this.customer.deliveryagentmasterid !== "undefined") {
          this.$http
            .post(`${CONSTANTS.API_URL}/AllocatePickupPincodes`, deliveryObj)
            .then(result => {
              alert("Added successfully");
              this.customer.pickuppincodestextarea = [];
              //document.getElementById("textareapincodes1").value = "";
              this.displaydata();
              this.pickupallocatetoggleInfo = !this.pickupallocatetoggleInfo;
              this.customer = {};
            })
            .catch(ex => {
              console.log("error", ex);
            });
        } else {
          alert("Please allocate delivery agent master id");
        }
      //}
    },
    PickupAllocateModal: function(value) {
      this.customer.deliveryagentmasterid = value.deliveryagentmasterid;
      this.customer.deliverypincodes = value.deliverypincodes;
      this.customer.deliveryagentpincode = value.deliveryagentpincode;
      this.customer.pickuppincodes = value.pickuppincodes;
      this.pickupallocatetoggleInfo = !this.pickupallocatetoggleInfo;
      this.pickupLocationModal = true;
      if (value.pickuppincodes) {
        var myObj = value.pickuppincodes;
        if (this.isJson(value.pickuppincodes)) {
          myObj = JSON.parse(myObj);
        }
        if (myObj) {
          var objStr = [];
          for (var i = 0; i < myObj.length; i++) {
            objStr.push(myObj[i].pickuppincode);
          }
          this.customer.pickuppincodestextarea = objStr;
          // console.log('pickuppincodestextarea',this.customer.pickuppincodestextarea);
          //document.getElementById("textareapincodes1").value = objStr;
        }
      }
    },
    editAgentMasterModal: function(value) {
      this.customer.deliveryagentpassword = value.deliveryagentpassword;
      this.customer.deliveryagentmasterid = value.deliveryagentmasterid;
      this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo;
    },    
    addAllowedAllocations: function(deliveryagentmasterid) {
      var inputnumber = document.getElementById(
        "totalAllocationsAllowedCls_" + deliveryagentmasterid
      ).value;
      if (isNaN(inputnumber) || inputnumber === "") {
        document.getElementById("msg" + deliveryagentmasterid).style.color =
          "red";
        document.getElementById("msg" + deliveryagentmasterid).innerHTML =
          " You need to enter a number";
        document.getElementById("msg" + deliveryagentmasterid).style.display =
          "block";
        return false;
      }
      inputnumber = Number(inputnumber);
      if (inputnumber < 0) {
        document.getElementById("msg" + deliveryagentmasterid).style.color =
          "red";
        document.getElementById("msg" + deliveryagentmasterid).innerHTML =
          "You need to enter a positive number";
        document.getElementById("msg" + deliveryagentmasterid).style.display =
          "block";
        return false;
      }
      document.getElementById("msg" + deliveryagentmasterid).innerHTML = "";
      document.getElementById("msg" + deliveryagentmasterid).style.display =
        "none";
      var totalallocations = document.getElementById(
        "totalAllocationsAllowedCls_" + deliveryagentmasterid
      ).value;
      if (totalallocations === "" || totalallocations < 0) {
        totalallocations = 0;
      }
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const customerGetobj = {
        deliveryagentmasterid: `${deliveryagentmasterid}`,
        totalallocationallowed: totalallocations,
        lastmodifiedby: `${userInfo.pickuplocationmasterid}`
      };
      this.$http
        .post(
          `${CONSTANTS.API_URL}/UpdateTotalAllocationAllowed`,
          customerGetobj
        )
        .then(result => {
          if (result.body[0].returnmsg === "successful") {
           Utils.notify("Total allocation added successfully", "success");
            document.getElementById(
              "totalAllocationsAllowedCls_" + deliveryagentmasterid
            ).value = totalallocations;
            document.getElementById(
              "totalAllocationsAllowedClsapen_" + deliveryagentmasterid
            ).innerHTML = totalallocations;
             // this.reloadPage();
          } else {
            Utils.notify(result.body.returnmsg, "error");
          }
        })
        .catch(ex => {
          console.log("error", ex);
        });
    },
     activateInActivateDeliveryAgent: function(value) {
      var deliveryagentmasterId = document.getElementById(
        "deliveryagentmasterId"
      ).value;
      var activeInactiveVal;
      if (this.customer.isactive === "1") {
        activeInactiveVal = "0";
      } else {
        activeInactiveVal = "1";
      }
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const customerGetobj = {
        deliveryagentmasterid: deliveryagentmasterId,
        isactive: activeInactiveVal,
        lastmodifiedby: `${userInfo.sysemailid}`
      };
      this.$http
        .post(
          `${CONSTANTS.API_URL}/ActivateInActivateDeliveryAgent`,
          customerGetobj
        )
        .then(result => {
          if(result.body.returnmsg ==="Unsuccessful")
          {
             alert("Shipments are allocated so can not InActive");
              this.toggleInfo = false;
         //this.displaydata();
         
        }
        else
        {
        alert("Status changed successfully");
          this.toggleInfo = false;
          this.displaydata();
        }
        })
        .catch(ex => {
          console.log("error", ex);
        });
    //  this.displaydata();
     // alert("Status changed successfully");
    },
    // activateInActivateDeliveryAgent: function(value) {
    //   var deliveryagentmasterId = document.getElementById(
    //     "deliveryagentmasterId"
    //   ).value;
    //   var activeInactiveVal;
    //   if (this.customer.isactive === "1") {
    //     activeInactiveVal = "0";
    //   } else {
    //     activeInactiveVal = "1";
    //   }
    //   var userdata = localStorage.getItem("userData");
    //   var userInfo = JSON.parse(userdata);
    //   const customerGetobj = {
    //     deliveryagentmasterid: deliveryagentmasterId,
    //     isactive: activeInactiveVal,
    //     lastmodifiedby: `${userInfo.sysemailid}`
    //   };
    //   this.$http
    //     .post(
    //       `${CONSTANTS.API_URL}/ActivateInActivateDeliveryAgent`,
    //       customerGetobj
    //     )
    //     .then(result => {
    //       this.toggleInfo = false;
    //       this.displaydata();
    //       //location.reload()
    //     })
    //     .catch(ex => {
    //       console.log("error", ex);
    //     });
    // //  this.displaydata();
    //   alert("Status changed successfully");
    // },
    getAllShipmentsListByStatus:function(type,button){
      if(type.cnt==0){
        Utils.notify('No Any shipments For '+type.name, "error");
      }else{
        this.allshipmentsbystatus.title=this.deliveryboyName +' - '+type.name;
        const agentObj = {
        deliveryagentmasterid: this.deliveryboyId,
        shipmentstatus:type.pageType
      };
      this.$http.post(
          `${
            CONSTANTS.MISREPORT_API_URL
          }/getallshipmentslistbystatus`,
          agentObj
        ).then(results => {
          // console.log(results);
           if (results.body.message.toLowerCase() === "success") {
           this.allshipmentsbystatus.data =results.body.data.shipment_list;
          this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)
          }else{
            this.allshipmentsbystatus.data =[];
           this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)

          }
        }).catch(ex => {
          console.log("error", ex);
        });
      }
    },



    getAllShipmentsListByStatus3PL:function(type,button){
      
      if(type.cnt==0){
        Utils.notify('No Any shipments For '+type.name, "error");
      }else{
        this.allshipmentsbystatus.title=this.deliveryboyName +' - '+type.name;
        const agentObj = {
        deliveryagentmasterid: this.deliveryboyId,
        shipmentstatus:type.pageType
      };
      this.$http.post(
          `${
            CONSTANTS.MISREPORT_API_URL
          }/getallshipmentslistbystatus3PL`,
          agentObj
        ).then(results => {
          // console.log(results);
           if (results.body.message.toLowerCase() === "success") {
           this.allshipmentsbystatus.data =results.body.data.shipment_list;
          this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)
          }else{
            this.allshipmentsbystatus.data =[];
           this.$root.$emit('bv::show::modal', this.allshipmentsbystatus.id, button)

          }
        }).catch(ex => {
          console.log("error", ex);
        });
      }
    },



    getconsignmentPickUpPendingList:function(type,button){
   
      if(type.cnt==0){
        Utils.notify('No Any shSpments For '+type.name, "error");
      }else{
        this.consignmentPickUpPendingList.title=type.orderflow.toUpperCase()+' Pickup';
        const agentObj = {
        id:`${this.deliveryboyId}`,
        pickuplocationmasterid:`${type.pickuplocationmasterid}`,
        mobilenumber:this.deliveryboyMb
        };

         
      this.$http.post(
          `${
            CONSTANTS.API_URL
          }/ConsignmentMaster.svc/GetConsignmentPickUpPendingList`,
          agentObj
        ).then(results => {
          // console.log('=======================');
          // console.log(results.data);
          // console.log('=======================');
           this.consignmentPickUpPendingList.title=type.orderflow.toUpperCase()+' Pickup('+ results.body.pendingshipments.length+')';
           this.consignmentPickUpPendingList.content=type;
           this.consignmentPickUpPendingList.data =results.body.pendingshipments;
           this.$root.$emit('bv::show::modal', this.consignmentPickUpPendingList.id, button)
        }).catch(ex => {
          console.log("error", ex);
        });
      }
    },
    deliveryDashbord:function(item, index, button){

      this.deliveryboyId=item.deliveryagentmasterid;
      this.deliveryboyName=item.deliveryagentfirstname+' '+ item.deliveryagentlastname;
      this.deliveryboyMb=item.deliveryagentmobilenumber;
      this.dashboardinfo.title = `Dashbord Info: ${item.deliveryagentfirstname.toUpperCase()} ${item.deliveryagentlastname.toUpperCase()}`; 
      this.dashboardinfo.content = JSON.stringify(item, null, 2);
      const agentObj = {
        deliveryagentmasterid: item.deliveryagentmasterid
      };
      this.$http.post(
          `${
            CONSTANTS.API_URL
          }/ConsignmentMaster.svc/GetAllDAPendingByAgent`,
          agentObj
        ).then(results => {
           if (results.body.returnmsg.toLowerCase() === "successful") {
         // dashboardinfoSuccessful
         this.dashboardinfo.data =results.body.returnvalue;
          this.$root.$emit('bv::show::modal', this.dashboardinfo.id, button)
              
              this.$http.post(
          `${
            CONSTANTS.MISREPORT_API_URL
          }/getalldapendingbyagent3PL`,
          agentObj
        ).then(results => {
          
         
         this.dashboardinfo3pl.data =results.body.returnvalue;
         
          
          }).catch(ex => {
          console.log("error", ex);
        });
        
          }
          else{
            //alert("teting else");
            this.dashboardinfo3pl.data =0;
           this.$root.$emit('bv::show::modal', this.dashboardinfo.id, button)

          }
        }).catch(ex => {
          console.log("error", ex);
        });
     },

    deliveryallocateModal: function(value) {
      this.customer.deliveryagentmasterid = value.deliveryagentmasterid;
      this.customer.deliverypincodes = value.deliverypincodes;
      this.customer.deliveryagentpincode = value.deliveryagentpincode;
      this.customer.pickuppincodes = value.pickuppincodes;
      this.delivertLocationModal = !this.delivertLocationModal;
      if (value.deliverypincodes) {
        var myObj = value.deliverypincodes;
        if (typeof myObj === "string") {
          myObj = JSON.parse(myObj);
        }
        if (myObj) {
          var objStr = [];
          for (var i = 0; i < myObj.length; i++) {
            objStr.push(myObj[i].deliverypincode);
          }
          this.customer.deliverypincodestextarea = objStr;
          // console.log('deliverypincodestextarea',this.customer.deliverypincodestextarea);
          //document.getElementById("textareapincodes").value = objStr;
        }
      }
    },
    addAgentInfo: function() {
      var chkmobileVal = this.chkmobileVal();
      if (chkmobileVal) {

        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        if (this.customer.isactive === "1") {
          this.customer.isactive = "1";
        } else {
          this.customer.isactive = "0";
        }
        this.customer.isverified = "1";
        this.customer.lastmodifiedby = `${userInfo.sysemailid}`;
        this.customer.deliveryagentpincode = `${
          userInfo.pickuplocationpincode
        }`;

        this.$validator.validateAll().then(result => {
          if (result) {
            this.$http
              .post(
                `${
                  CONSTANTS.API_URL
                }/DeliveryAgentMaster.svc/DeliveryAgentSignUpHub`,
                this.customer
              )
              .then(results => {
              // console.log(results.body[0].returnmsg)
                if (results.body[0].returnmsg === "Successful") {
                  Utils.notify("Added successfully", "success");
                  this.customer = {};
                  this.displaydata();
                   var adduser = document.getElementById("adduser");
                   adduser.style.display = "none";
                   this.$router.push('/deliveryagentmaster');
                } else {
                  alert(results.body[0].returnvalue);
                 Utils.notify(results.body[0].returnvalue, "error");
                }
              })
              .catch(ex => {
                console.log("error", ex);
              });
          } else {
            Utils.notify("Correct them errors", "error");
          }
        });
      } else {
        Utils.notify("Please enter valid mobile number", "error");
      }
    },
  },
  filters: {
    datechange: function(value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    },
    capitalize: function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.custom-scrollbar {
position: relative;
height: 200px;
overflow: auto;
}
.table-wrapper-scroll-y {
display: block;
}

</style>
